import React, { Component } from 'react';
import { Page } from 'framework7-react';
import './PostResetOptionsPopup.css';
import Popup from "../popup/Popup";
import PrimaryButton from "../../primaryButton/PrimaryButton";
import SecondaryButton from "../../secondaryButton/SecondaryButton";
import Label from "../../label/Label";
import mainAPI from "../../../api/MainAPI";
import copyToClipboard from "../../../utils/copyToClipboard";

export default class PostResetOptionsPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			opened: this.props.opened || false,
			isDesktop: false
		};
		this.shortTermToken = null;
	}

	async componentDidMount() {
		// Set opened to true when component mounts
		this.setState({ opened: true });

		this.resetToken();

		// Detect if user is on desktop
		this.detectDesktop();
	}

	detectDesktop = () => {
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
		const isTablet = /iPad|Android(?=.*\bMobile\b)(?=.*\bSafari\b)/i.test(userAgent);
		
		// Consider it desktop if not mobile and not tablet
		const isDesktop = !isMobile && !isTablet;
		
		this.setState({ isDesktop });
	};

	copyTokenAndOpenAppStore = async () => {
		await this.copyToken();
		await setTimeoutAsync(50);
		this.openAppStore();
		this.resetToken()
	}

	copyToken = async () => {
		try {
			const shortTermToken = await this.shortTermToken;
			await copyToClipboard(shortTermToken.id, false);
		} catch (e) {
			console.log('Error during download process:', e);
			// Continue with download even if clipboard fails
		}

	}

	openAppStore = () => {
		
		// Determine OS and set appropriate download URL
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
		const isAndroid = /android/i.test(userAgent);
		
		let downloadUrl = 'https://apps.apple.com/app/id1095064884'; // Default to iOS
		if (isAndroid) {
			downloadUrl = 'https://play.google.com/store/apps/details?id=com.logrx.main';
		}
		
		// Open app store in new tab/window
		window.open(downloadUrl, '_blank');
	};

	resetToken = () => {
		this.shortTermToken = mainAPI.short_term_token.create();
	};

	handleGoToApp = async () => {

		try {
			// Get the short term token
			const shortTermToken = await this.shortTermToken;
			this.resetToken();
			// Create deep link with token
			const deepLink = `logrx://app/login?temp_token=${shortTermToken.id}`;
			
			// Try to open the app using deep link
			window.location.href = deepLink;
		} catch (error) {
			console.log('Error creating deep link:', error);
		}
	};

	render() {
		const { isDesktop } = this.state;
		
		return (
			<Popup opened={this.state.opened} className="g-post-reset-options-popup" tabletFullscreen={true}>
				<Page>
					<Label className='center top-label' large dark bold>
						Password Reset Successful!
					</Label>
					
					<div className="success-message">
						<Label className='center' dark>
							Your password has been successfully reset
						</Label>
					</div>

					{isDesktop ? (
						<div className="desktop-message">
							<Label className='center' dark>
								Now open the app to continue
							</Label>
						</div>
					) : (
						<div className="button-container">
							<PrimaryButton 
								className='center download-button' 
								onClick={this.copyTokenAndOpenAppStore}
							>
								Download the App
							</PrimaryButton>
							
							<SecondaryButton 
								className='center go-to-app-button' 
								onClick={this.handleGoToApp}
							>
								Go to the App
							</SecondaryButton>
						</div>
					)}
				</Page>
			</Popup>
		);
	}
}

const setTimeoutAsync = (ms) => {
	return new Promise(resolve => setTimeout(resolve, ms));
};
